export default "__VITE_ASSET__89bc48bf__"